// extracted by mini-css-extract-plugin
export default {"buy":"buy_buy__fVxdD","title":"buy_title__KiVwl","icon":"buy_icon__ESgh8","contenido":"buy_contenido__aztxj"};